import type { RequestFormMode } from "@RequestFormV2/context/requestFormMode";

const FIELD_TO_SECTION: Record<string, string> = {
  organizational: "request-form.organisation",
  service: "request-form.service",
  invited_modes: "request-form.service",
  schedule: "request-form.schedule",
  packing_list: "request-form.packingList",
  shipment: "request-form.provider",
  invited_providers: "request-form.provider",
  bucket_attachments: "request-form.provider",
  other_attachments: "request-form.provider",
};

const ATTACHMENT_FIELD_TO_SECTION: Record<string, string> = {
  bucket_attachments: "request-form.attachments",
  other_attachments: "request-form.attachments",
};

const CLEARANCE_FIELD_PATTERN = /^service\.(export|import|transit)_clearance(_instructions)?$/;

export function getSectionKeyForFieldPath(fieldPath: string, mode: RequestFormMode = "quote"): string | undefined {
  if (fieldPath === "shipment.title" || fieldPath === "quick_request.title") {
    return "request-form.organisation";
  }
  if (CLEARANCE_FIELD_PATTERN.test(fieldPath)) {
    return "request-form.schedule";
  }
  if (fieldPath === "service.service_level") {
    return "request-form.schedule";
  }
  const topLevel = fieldPath.split(".")[0];

  if (mode === "quick" && topLevel in ATTACHMENT_FIELD_TO_SECTION) {
    return ATTACHMENT_FIELD_TO_SECTION[topLevel];
  }

  return FIELD_TO_SECTION[topLevel];
}
